import details from './details'
import { update, updateUsageType } from './updateSingle'
import { batchUpdateSpaceTypes, batchUpdateUsageTypes } from './updateMulti'
import allocate from './allocate'
import seat from './seat'
import search from './search'
import spaceType from './spaceType'
import createSpaceAssets from './spaceAssets'
import deleteSpaceAsset from './deleteSpaceAsset'
import setDefaultSpaceAssets from './setDefaultSpaceAssets'
import assets from './assets'
import createSpaceAsset from './spaceAsset'
import { updateSpacez } from './updateSpacez'
import unAllocate from './unAllocate'
import { createCalendarEvent } from './createCalendarEvent'
import getSpaceCoordinates from './getSpaceCoordinate'

export default {
  details,
  update,
  updateUsageType,
  batchUpdateSpaceTypes,
  batchUpdateUsageTypes,
  allocate,
  seat,
  search,
  spaceType,
  createSpaceAssets,
  createSpaceAsset,
  deleteSpaceAsset,
  setDefaultSpaceAssets,
  assets,
  updateSpacez,
  unAllocate,
  createCalendarEvent,
  getSpaceCoordinates,
}
